import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

import InfoMessage from "@components-shared/InfoMessageComponent";
import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";

export default function EmptyMyBetsMessage() {
	const { t } = useTranslation();
	const store = useContext(MyBetsStoreContext);

	if (store == null || store.type != "MyBetsStore") {
		console.error("Expected store, got null");
		return null;
	}

	let messageStr = t<string>("mybets:PAGE.NO_BET_SLIP");

	if (store.location == "AdditionalOffer") {
		messageStr = t("mybets:PAGE.NO_OPEN_BETS_ON_EVENT");
	}

	return (
		<div className="section--filled">
			<div className="card">
				<InfoMessage
					type="empty"
					message={messageStr}
					emptyIcon="u-icon--empty--bets"
				/>
			</div>
		</div>
	);
}
